import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { BlockQuoteProps } from '@ts-blocks/block-quote/interfaces'

interface BlockQuoteHookOptions {
  block: () => BlockQuoteProps
}

interface BlockQuoteHookReturn {
  refImageAlt: ComputedRef<string>
}

export const useBlockQuote = ({ block }: BlockQuoteHookOptions): BlockQuoteHookReturn => {
  const refImageAlt = computed<string>(() => block().image?.alternativeText ?? block().personName)

  return {
    refImageAlt,
  }
}
